import { Link } from 'react-router-dom'
import { Icon } from '../components/Icon'

export function NotFoundPage() {
  return <div className="page-width not-found"><span>404</span><h1>That course page was not found</h1><p>Return to the course map or search all modules.</p><div><Link className="button primary" to="/"><Icon name="home" size={17} />Course home</Link><Link className="button" to="/search"><Icon name="search" size={17} />Search</Link></div></div>
}
